export default __webpack_public_path__ + "static/media/cta_pattern.755e18ec.svg";